
angular.module('impactx.rfx').controller('RFXSupplierEditValidityDateCtrl', [
    '$scope',
    'TranslationService',
    '$mdDialog',
    'AppConfiguration',
    'dataGen',
    RFXSupplierEditValidityDateCtrl
]);

function RFXSupplierEditValidityDateCtrl($scope, TranslationService, $mdDialog, AppConfiguration, dataGen) {
    var self = this;
    self.save = function () {
        $mdDialog.hide($scope.date)
    };

    self.abort = function () {
        $mdDialog.cancel();
    };
    $scope.date = JSON.parse(JSON.stringify(self.date));
    $scope.date.readOnly = false;
    $scope.mindate = new Date();

}
